<template>
  <div class="row">
    <div class="col-12">
      <h4 class="my-galleries">
        {{$t("albums.myAlbums")}}
      </h4>
    </div>

    <div class="row">
      <div class="col-md-4" v-for="album in albums" :key="album.id">
        <div class="event-card card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <router-link target='_blank' :to="{name: 'ShowEventAlbum', 
                  params: {
                    id: album.event.identifier.toString(), 
                    album_id: album.identifier
                  }
                }">
                  <img :src="album.event.banner_url" class="card-img-top" alt="event.name">
                </router-link>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-7 col-7">
                <p class="date">{{ album.items }} {{ $t("photos")}}</p>
                <router-link target='_blank' :to="{name: 'ShowEventAlbum', 
                  params: {
                    id: album.event.identifier.toString(), 
                    album_id: album.identifier
                  }
                }">
                  <p class="name">{{$t("albums.showAlbum")}}</p>
                </router-link>
              </div>
              <div class="col-lg-5 col-5">
                <div v-if="album.event.sale">
                  <div class="cart" @click="addToCart(album.event.identifier)">
                      <i class="fas fa-shopping-cart"></i>
                  </div>
                  <div v-if="album.event.active_pre_order">
                    <p class="price" v-if="album.event.price_album === 0"></p>
                    <p class="price" v-else>{{album.event.pre_order_item.discount_price | toCurrency}}</p>
                  </div>
                  <div v-else>
                    <p class="price" v-if="album.event.price_album === 0"></p>
                    <p class="price" v-else>{{ album.event.price_album | toCurrency }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from "../../models/User";
import ShoppingCart from "../../models/ShoppingCart"
import { UserAlbumApi } from "../../api/UserAlbumApi";

export default {
  name: "MyAlbums",
  data(){
    return{
      user: new User(),
      albums: [],
      shoppingCart: new ShoppingCart(),
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.albums = await UserAlbumApi.fetch();
      this.loading = false;
    },
    async addToCart(eventId) {
      const params = {event_id: eventId, photo_id: null}
      this.$alertify.success(this.$t("checkout.addedItem"))
      await this.shoppingCart.addItem(params)
      this.$root.$emit("addItemToCart", params)
    },
  },
}
</script>

<style lang="scss">
  .my-galleries {
    text-align: left;
  }
</style>
